<template>
	<div class="data-ingedit">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/datacenter/dishes' }">菜品</el-breadcrumb-item>
			<el-breadcrumb-item>编辑基本信息</el-breadcrumb-item>
		</el-breadcrumb>
		<el-row style="margin-top:15px">
			<el-col style="width:200px;">
				<div class="photo">
					<el-upload
						class="avatar-uploader"
						style="border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
		height: 123px;"
						:action="uploadUrl"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<el-image
							v-if="dishesForm.dishesImage"
							style="width: 200px; height: 125px;"
							:src="dishesForm.dishesImageUrl"
							fit="cover"></el-image>
						<i v-else class="el-icon-plus avatar-uploader-icon_1"></i>
						<div class="test_1" v-if="dishesForm.dishesImage">
							<div style="width:100px;height:125px;background: rgb(225, 225, 225);line-height:148px;float: left;">
								<svg-icon
								icon-class="upload"
								style="width:2em;height:2em;"
								></svg-icon>
							</div>
							<div style="width:100px;height:125px;background: rgb(250, 250, 250);line-height:148px;float: right" @click.stop="delImage($event)">
								<svg-icon
								icon-class="del"
								style="width:2em;height:2em;"
								></svg-icon>
							</div>
						</div>
					</el-upload>
				</div>
			</el-col>
			<el-col :span="15" style="padding-left:30px;text-align:left;">
				<el-form :model="dishesForm" label-position="right" :rules="rules" ref="dishesForm" label-width="80px" class="demo-dishesForm">
					<el-form-item label="菜品名称" prop="dishesName">
						<el-input v-model="dishesForm.dishesName"></el-input>
					</el-form-item>
					<el-form-item label="别   名" prop="aliasName" style="text-align: left;">
						<span style="display:inline-block"><el-input v-model="dishesForm.aliasName" placeholder="多个请用英文逗号','分开" style="width:170px;"></el-input></span>
						<span style="display:inline-block;margin-left: 130px;">编   号<el-input v-model="dishesForm.dishesCode" placeholder="请输入编号" style="width:190px;"></el-input></span>
					</el-form-item>
					<el-form-item label="菜型" required style="margin-bottom:0;">
						<el-row :gutter="1">
							<el-col :span="7">
								<el-form-item prop="dishType" label="">
									<el-input v-model="dishesForm.dishType" style="width:160px;" placeholder="请输入菜型"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="7">
								<el-form-item prop="bigCateId" label-width="60px" label="类别">
									<el-select v-model="dishesForm.bigCateId" placeholder="请选择" style="width:145px" @change="changeBigCate">
										<el-option
											v-for="item in dishesCateList"
											:key="item.cateName"
											:label="item.cateName"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="7">
								<el-form-item prop="smallCateId" label-width="100px" label="小类">
									<el-select v-model="dishesForm.smallCateId" placeholder="请选择" style="width:145px" @change="getSmallCateName">
										<el-option
											v-for="item in smallCateList"
											:key="item.cateName"
											:label="item.cateName"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item>
					<el-form-item label="烹饪技法" required>
						<el-row :gutter="1">
							<el-col :span="7">
								<el-form-item prop="techniqueDictValue" label="">
									<el-select v-model="dishesForm.techniqueDictValue" placeholder="请选择" style="width:160px" @change="getTechniqueName">
										<el-option
											v-for="item in techniquesList"	
											:key="item.name"
											:label="item.name"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="7">
								<el-form-item prop="meatVegetables" label-width="60px" label="荤素">
									<el-select v-model="dishesForm.meatVegetables" placeholder="请选择" style="width:145px">
										<el-option
											v-for="item in meatVegetablesList"
											:key="item.value"
											:label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="7">
								<el-form-item  label-width="100px" label="清真">
									<div style="width: 145px;">
										<el-switch
											v-model="dishesForm.halalFlag"
											active-color="#13ce66">
										</el-switch>
										<span class="_tips">{{dishesForm.halalFlag?'清真':'非清真'}}</span>
									</div>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item>
					<el-form-item label="药食同源">
						<div style="width: 145px;font-size:12px">
							<el-switch
								v-model="dishesForm.homologousFlag"
								:active-value="1"
								:inactive-value="0"
								active-color="#13ce66">
							</el-switch>
							<span class="_tips">{{dishesForm.homologousFlag==1?'是':'否'}}</span>
						</div>
					</el-form-item>
				</el-form>
				<el-divider></el-divider>
				<el-form label-position="top" label-width="80px" >
					<el-form-item label="食材带量搭配">
						<el-select v-model="crowdId" disabled placeholder="请选择" style="width:160px" @change="handSelectCrowd">
							<el-option
								v-for="item in crowdList"
								:key="item.name"
								:label="item.name"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="主料" :style="{'position': 'relative','margin-bottom':'0'}">
						<draggable group="people" v-model="dishesForm.ingredientsWeights['1']">
							<el-row v-for="(item,index) in dishesForm.ingredientsWeights['1']" :key="index">
								<el-col :span="20" style="width:350px;">
									<div class="list-group-item">
										<span class="list-group-content" style="cursor:move">
											<span style="display:inline-block;">{{item.ingredientsName}}</span>
											<!-- <el-input v-model="item.weight" style="width:80px;" @change="computeElementsWeight"></el-input> -->
											<span style="float:right">
												<el-input-number v-model="item.weight" style="width:97px;" controls-position="right" :step="0.1" :min="0.1" :max="999.9" :precision="1" @change="(val, oldValue)=>computeElementsWeight(val,item)"></el-input-number>
												<span>克</span>
											</span>
											<span class="del" @click="remove(index,dishesForm.ingredientsWeights['1'],item)">
												<span style="border: 1px solid rgb(225, 225, 225);height: 1px;width: 20px;margin-bottom: 5px;"></span>
											</span>
										</span>
									</div>
								</el-col>
								<el-col :span="1">
								</el-col>
							</el-row>
						</draggable>
							<div style="margin-bottom: 10px;margin-top: 8px;">
								<el-select
										v-model="major"
										style="width: 320px;"
										:remote-method="querySearchAsync"
										placeholder="搜索食材"
										clearable
										filterable
										remote
										@change="(item)=>handleSelect(item,'1')">
										<el-option
												v-for="item in options"
												:key="item.value"
												:label="item.value"
												:value="item.id">
											</el-option>
									</el-select>
              </div>
							<div class="elms_ranking">
								<div style="text-align: left;margin-bottom: 6px;">总营养素</div>
								<div class="ingredients_map">
									<span class="ingredients_map_name">能量</span>
									<span class="ingredients_map_weight">{{elements.energyKc}}</span>
									<span class="ingredients_map_unit">千卡</span>
								</div>
								<div class="ingredients_map">
									<span class="ingredients_map_name">碳水化合物</span>
									<span class="ingredients_map_weight">{{elements.carbohydrate}}</span>
									<span class="ingredients_map_unit">克</span>
								</div>
								<div class="ingredients_map">
									<span class="ingredients_map_name">蛋白质</span>
									<span class="ingredients_map_weight">{{elements.protein}}</span>
									<span class="ingredients_map_unit">克</span>
								</div>
								<div class="ingredients_map">
									<span class="ingredients_map_name">脂肪</span>
									<span class="ingredients_map_weight">{{elements.fat}}</span>
									<span class="ingredients_map_unit">克</span>
								</div>
								<div class="ingredients_map">
									<span class="ingredients_map_name">钙</span>
									<span class="ingredients_map_weight">{{elements.autunite}}</span>
									<span class="ingredients_map_unit">毫克</span>
								</div>
								<div class="ingredients_map">
									<span class="ingredients_map_name">铁</span>
									<span class="ingredients_map_weight">{{elements.iron}}</span>
									<span class="ingredients_map_unit">毫克</span>
								</div>
								<div class="ingredients_map">
									<span class="ingredients_map_name">锌</span>
									<span class="ingredients_map_weight">{{elements.zicn}}</span>
									<span class="ingredients_map_unit">毫克</span>
								</div>
								<div class="ingredients_map">
									<span class="ingredients_map_name">维生素A</span>
									<span class="ingredients_map_weight">{{elements.va}}</span>
									<span class="ingredients_map_unit">微克</span>
								</div>
								<div class="ingredients_map">
									<span class="ingredients_map_name">维生素B1</span>
									<span class="ingredients_map_weight">{{elements.vb1}}</span>
									<span class="ingredients_map_unit">毫克</span>
								</div>
								<div class="ingredients_map">
									<span class="ingredients_map_name">维生素B2</span>
									<span class="ingredients_map_weight">{{elements.vb2}}</span>
									<span class="ingredients_map_unit">毫克</span>
								</div>
								<div class="ingredients_map">
									<span class="ingredients_map_name">维生素C</span>
									<span class="ingredients_map_weight">{{elements.vc}}</span>
									<span class="ingredients_map_unit">毫克</span>
								</div>
							</div>
					</el-form-item>
					<el-form-item label="辅料" style="margin-bottom:0;">
						<draggable group="people" v-model="dishesForm.ingredientsWeights['2']" v-if="dishesForm.ingredientsWeights">
							<el-row v-for="(item,index) in dishesForm.ingredientsWeights['2']" :key="index">
									<el-col :span="20" style="width:350px;">
										<div class="list-group-item">
											<span class="list-group-content" style="cursor:move">
												<span style="display:inline-block;">{{item.ingredientsName}}</span>
												<!-- <el-input v-model="item.weight" style="width:80px;" @change="computeElementsWeight"></el-input> -->
												<span style="float:right">
													<el-input-number v-model="item.weight" style="width:97px;" controls-position="right" :step="0.1" :min="0.1" :max="999.9" :precision="1" @change="(val, oldValue)=>computeElementsWeight(val,item)"></el-input-number>
													<span>克</span>
												</span>
												<span class="del" @click="remove(index,dishesForm.ingredientsWeights['2'],item)">
													<span style="border: 1px solid rgb(225, 225, 225);height: 1px;width: 20px;margin-bottom: 5px;"></span>
												</span>
											</span>
										</div>
									</el-col>
									<el-col :span="1">
									</el-col>
							</el-row>
						</draggable>
						<div style="margin-bottom: 10px;margin-top: 8px;">
							<el-select
									v-model="accessories"
									style="width: 320px;"
									:remote-method="querySearchAsync"
									placeholder="搜索食材"
									clearable
									filterable
									remote
									@change="(item)=>handleSelect(item,'2')">
									<el-option
											v-for="item in options"
											:key="item.value"
											:label="item.value"
											:value="item.id">
										</el-option>
							</el-select>
						</div>
					</el-form-item>
					<el-form-item label="调料" style="margin-bottom:0;">
						<draggable group="aa" v-model="dishesForm.ingredientsWeights['3']" v-if="dishesForm.ingredientsWeights">
							<el-row v-for="(item,index) in dishesForm.ingredientsWeights['3']" :key="index">
								<el-col :span="20" style="width:350px;">
									<div class="list-group-item">
										<span class="list-group-content" style="cursor:move">
											<span style="display:inline-block;">{{item.ingredientsName}}</span>
											<!-- <el-input v-model="item.weight" style="width:80px;" @change="computeElementsWeight"></el-input> -->
											<span style="float:right">
												<el-input-number v-model="item.weight" style="width:97px;" controls-position="right" :step="0.1" :min="0.1" :max="999.9" :precision="1" @change="(val, oldValue)=>computeElementsWeight(val,item)"></el-input-number>
												<span>克</span>
											</span>
											<span class="del" @click="remove(index,dishesForm.ingredientsWeights['3'],item)">
												<span style="border: 1px solid rgb(225, 225, 225);height: 1px;width: 20px;margin-bottom: 5px;"></span>
											</span>
										</span>
									</div>
								</el-col>
								<el-col :span="1">
								</el-col>
							</el-row>
						</draggable>
							<div style="margin-bottom: 10px;margin-top: 8px;">
								<el-select
									v-model="seasoning"
									style="width: 320px;"
									:remote-method="querySearchAsync"
									placeholder="搜索食材"
									clearable
									filterable
									remote
									@change="(item)=>handleSelect(item,'3')">
									<el-option
											v-for="item in options"
											:key="item.value"
											:label="item.value"
											:value="item.id">
										</el-option>
							</el-select>
              </div>
					</el-form-item>
					<el-form-item label="可扩展辅料" style="margin-bottom:0;">
						<el-row v-for="(item,index) in  dishesForm.ingredientsWeights['4']" :key="index">
								<el-col :span="20" style="width:350px;">
									<div class="list-group-item">
										<span class="list-group-content">
											<span style="display:inline-block;">{{item.ingredientsName}}</span>
											<!-- <el-input v-model="item.weight" style="width:80px;" @change="computeElementsWeight"></el-input> -->
											<span style="float:right">
												<el-input-number v-model="item.weight" style="width:97px;" controls-position="right" :step="0.1" :min="0.1" :max="999.9" :precision="1"></el-input-number>
												<span>克</span>
											</span>
											<span class="del" @click="remove(index,dishesForm.ingredientsWeights['4'],item)">
												<span style="border: 1px solid rgb(225, 225, 225);height: 1px;width: 20px;margin-bottom: 5px;"></span>
											</span>
										</span>
									</div>
								</el-col>
								<el-col :span="1">
								</el-col>
							</el-row>
							<div style="margin-bottom: 10px;margin-top: 8px;">
								<el-select
									v-model="seasoning"
									style="width: 320px;"
									:remote-method="querySearchAsync"
									placeholder="搜索食材"
									clearable
									filterable
									remote
									@change="(item)=>handleSelect(item,'4')">
									<el-option
											v-for="item in options"
											:key="item.value"
											:label="item.value"
											:value="item.id">
										</el-option>
							</el-select>
              </div>
					</el-form-item>
				</el-form>
				<el-divider></el-divider>
				<el-form label-position="top" label-width="80px" >
					<el-form-item label="色泽特征">
						<el-select v-model="dishesForm.colorDictValue" placeholder="请选择" style="width:160px" @change="getDishesColorName">
							<el-option
								v-for="item in cishesColorList"
								:key="item.name"
								:label="item.name"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<el-divider></el-divider>
				<el-form label-position="top" label-width="80px">
					<el-form-item label="菜品特点" :style="{'position': 'relative'}">
						<span class="_tips dishes_features_tips">最多选择5项</span>
						<div style="border:1px solid #cccccc;min-height:35px;line-height:35px;width:90%;padding-left:10px">
							<el-tag
								v-for="tag in dishesForm.features"
								:key="tag.valueDictName"
								closable
								effect="dark"
								type="info"
								@close="handleTagClose(tag)">
								{{tag.valueDictName}}
							</el-tag>
						</div>
					</el-form-item>
					<el-form-item :label="item.itemDictName" v-for="(item, index) in featureList" :key="index">
						<el-tag
							v-for="tag in item.dishesFeatureModelList"
							:key="tag.valueDictName"
							effect="dark"
							type="info"
							@click="handlePickTag(tag,item)">
							{{tag.valueDictName}}
						</el-tag>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<el-row style="position: fixed;bottom:3px;padding-left:35%">
			<el-button type="primary" @click="onSubmit">保存</el-button>
    	<el-button @click="goBack()">取消</el-button>
		</el-row>
	</div>
</template>

<script>
import draggable from "vuedraggable";
import { queryDishesFeature,fetchDictListByType } from '@/api/dict'
import { fetchDishesCateList } from '@/api/aicenter'
import { queryByKeyWord,getUploadUrl } from '@/api/catering/ingredient'
import {saveDishes,updateDishes,queryDishesDetail,queryIngredientsList} from '@/api/catering/dishes'
export default {
  name: "DishesInfo",
	components: {
		draggable
	},
  data() {
    return {
			state: null,
			options: [],
			elements: {
				energyKc:0,
				carbohydrate:0,
				protein:0,
				fat:0,
				autunite:0,
				iron:0,
				zicn:0,
				va:0,
				vb1:0,
				vb2:0,
				vc:0
			},
			rules: {
				dishesName: [
					{ required: true, message: '请输入菜品名称', trigger: 'blur' },
					{ min: 1, max: 25, message: '长度在 1 到 25 个字符', trigger: 'blur' }
				],
				// aliasName: [
				// 	{ required: true, message: '请输入菜品别名', trigger: 'blur' },
				// 	{ min: 1, max: 25, message: '长度在 1 到 25 个字符', trigger: 'blur' }
				// ],
				dishType: [
					{ required: true, message: '请输入菜形', trigger: 'blur' }
				],
				bigCateId: [
					{ required: true, message: '请选择类别', trigger: 'change' }
				],
				smallCateId: [
					{ required: true, message: '请选择小类', trigger: 'change' }
				],
				techniqueDictValue: [
					{ required: true, message: '请选择烹饪技法', trigger: 'change' }
				],
				meatVegetables: [
					{ required: true, message: '请选择荤素', trigger: 'change' }
				]
			},
			dishesCateList: [],
			smallCateList: [],
			meatVegetablesList: [
				{label: '素菜', value: 0},
				{label: '荤菜', value: 1}
			],
			crowdId: "1",
			crowdList: [],
			major: null,
			accessories: null,
			seasoning: null,
			extAccessories: null,
			techniquesList: [],
			featureList: [],
			cishesColorList: [],
			uploadUrl: null,
			dishesForm: {
				id: null,
				dishesImage: null,
				dishesImageUrl: null,
				dishesName: null,
				aliasName: null,
				dishType: null,
				bigCateId: null,
				bigCateName: null,
				smallCateId: null,
				smallCateName: null,
				meatVegetables: null,
				techniqueDictValue: null,
				techniqueDictName: null,
				halalFlag: true,
				homologousFlag: 0,
				ingredientsWeights: {
					'1': [],
					'2': [],
					'3': [],
					'4': []
				},
				colorDictName: null,
				colorDictValue: null,
				features: []
			}
    };
  },
	created() {
		this.getUploadUrl();
		this.queryDishesCateList();
		this.queryDishesFeatureList();
		this.queryDictByTypeList('technique');
		this.queryDictByTypeList('crowd');
		this.queryDictByTypeList('cishes_color');
		this.queryDishesDetail(this.$route.query.uid);
	},
  methods: {
	  getUploadUrl() {
			this.uploadUrl = getUploadUrl();
		},
		handleAvatarSuccess(res, file) {
        this.dishesForm.dishesImageUrl = URL.createObjectURL(file.raw);
				this.dishesForm.dishesImage = res.data; 
		},
		beforeAvatarUpload(file) {
			const isJPG = file.type === 'image/jpeg';
			const isPng = file.type === 'image/png';
			const isLt2M = file.size / 1024 / 1024 < 0.5;

			if (!isJPG && !isPng) {
				this.$message.error('上传菜品图片只能是 JPG或PNG 格式!');
			}
			if (!isLt2M) {
				this.$message.error('上传菜品图片大小不能超过 500KB!');
			}
			return (isPng || isJPG) && isLt2M;
		},
		delImage(dd) {
			this.dishesForm.dishesImage = null;
			this.dishesForm.dishesImageUrl = null;
		},
		queryDishesCateList() {
			fetchDishesCateList().then(response=>{
				this.dishesCateList = response.data;
				if(this.$route.query.uid) {
					this.changeEditBigCate(this.dishesForm.bigCateId);
				}
			});
		},
		changeEditBigCate(cateId) {
			this.dishesCateList.map(item=> {
				if(item.id==cateId) {
					this.smallCateList = item.smallCateList;
					this.dishesForm.bigCateName = item.cateName;
				}
			});
		},
		changeBigCate(cateId) {
			this.dishesForm.smallCateId = null;
			this.dishesForm.smallCateName = null;
			this.dishesCateList.map(item=> {
				if(item.id==cateId) {
					this.smallCateList = item.smallCateList;
					this.dishesForm.bigCateName = item.cateName;
				}
			});
		},
		getSmallCateName(cateId) {
			let smallObj = this.smallCateList.filter(item=>{
				return item.id == cateId;
			})
			this.dishesForm.smallCateName = smallObj[0].cateName;
		},
		getTechniqueName(value) {
			let techObj = this.techniquesList.filter(item=>{
				return item.value == value;
			})
			this.dishesForm.techniqueDictName = techObj[0].name;
		},
		getDishesColorName(value) {
			let techObj = this.cishesColorList.filter(item=>{
				return item.value == value;
			})
			this.dishesForm.colorDictName = techObj[0].name;
		},
		queryDictByTypeList(code) {
			fetchDictListByType(code).then(response=>{
				if(code == 'technique') {
					this.techniquesList = response.data;
				}
				if(code == 'crowd') {
					this.crowdList = response.data;
				}
				if(code == 'cishes_color') {
					this.cishesColorList = response.data;
				}
			});
		},
		queryDishesFeatureList() {
			queryDishesFeature().then(response=>{
				this.featureList = response.data;
			})
		},
		querySearchAsync(queryString, cb) {
      if(queryString) {
        queryByKeyWord({keyWord:queryString}).then(response=>{
          let result = response.data.map(item=>{
            return Object.assign({value: item.commonName,id:item.id},item)
          })
          // cb(result)
					this.options = result;
        })
      }
    },
		handSelectCrowd(val) {

		},
		handleSelect(val, name) {
			let smallObj = this.options.filter(item=>{
				return item.id == val;
			})
			let item = smallObj[0];
			let ingredient = {ingredientsName: item.value,ingredientsId:item.id, crowdDictValue:this.crowdId,weight: 0.1};
			if(name == '1') {
				ingredient.type = 1;
				ingredient.typeStr = '主料';
				this.major = ''
			}
			if(name == '2') {
				ingredient.type = '辅料'
				ingredient.type = 2;
				this.accessories = ''
			}
			if(name == '3') {
				ingredient.type = 3;
				ingredient.type = '调料'
				this.seasoning = ''
			}
			if(name == '4') {
				ingredient.type = 4;
				ingredient.typeStr = '可扩展辅料'
				this.extAccessories = ''
			}
			Object.assign(ingredient,{elements:item});
			this.options = [];
			this.dishesForm.ingredientsWeights[name].push(ingredient);
		},
		remove(index,list,item) {
      list.splice(index,1);
			this.computeElementsWeight(0,item);
    },
		computeElementsWeight(val,item) {
			let energyKc=0,carbohydrate=0,protein=0,fat=0,
					autunite=0,	iron=0,zicn=0,va=0,
					vb1=0,vb2=0,vc=0;
			if(!val) val = 0;
			for(let index=1;index<4;index++) {
					let weightArray = this.dishesForm.ingredientsWeights[index];
					if(weightArray.length>0) {
						weightArray.map(w=>{
							val = w.weight;
							if(!w.elements) {
								energyKc += val/10000*w.eatPart*(Number.isNaN(parseFloat(w.energyKc))?0:w.energyKc);
								carbohydrate += val/10000*w.eatPart*(Number.isNaN(parseFloat(w.carbohydrate))?0:w.carbohydrate);
								protein += val/10000*w.eatPart*(Number.isNaN(parseFloat(w.protein))?0:w.protein);
								fat += val/10000*w.eatPart*(Number.isNaN(parseFloat(w.fat))?0:w.fat);
								autunite += val/10000*w.eatPart*(Number.isNaN(parseFloat(w.autunite))?0:w.autunite);
								iron += val/10000*w.eatPart*(Number.isNaN(parseFloat(w.iron))?0:w.iron);
								zicn += val/10000*w.eatPart*(Number.isNaN(parseFloat(w.zicn))?0:w.zicn);
								va += val/10000*w.eatPart*(Number.isNaN(parseFloat(w.va))?0:w.va);
								vb1 += val/10000*w.eatPart*(Number.isNaN(parseFloat(w.vb1))?0:w.vb1);
								vb2 += val/10000*w.eatPart*(Number.isNaN(parseFloat(w.vb2))?0:w.vb2);
								vc += val/10000*w.eatPart*(Number.isNaN(parseFloat(w.vc))?0:w.vc);
							} else {
								energyKc += val/10000*w.elements.eatPart*(Number.isNaN(parseFloat(w.elements.energyKc))?0:w.elements.energyKc);
								carbohydrate += val/10000*w.elements.eatPart*(Number.isNaN(parseFloat(w.elements.carbohydrate))?0:w.elements.carbohydrate);
								protein += val/10000*w.elements.eatPart*(Number.isNaN(parseFloat(w.elements.protein))?0:w.elements.protein);
								fat += val/10000*w.elements.eatPart*(Number.isNaN(parseFloat(w.elements.fat))?0:w.elements.fat);
								autunite += val/10000*w.elements.eatPart*(Number.isNaN(parseFloat(w.elements.autunite))?0:w.elements.autunite);
								iron += val/10000*w.elements.eatPart*(Number.isNaN(parseFloat(w.elements.iron))?0:w.elements.iron);
								zicn += val/10000*w.elements.eatPart*(Number.isNaN(parseFloat(w.elements.zicn))?0:w.elements.zicn);
								va += val/10000*w.elements.eatPart*(Number.isNaN(parseFloat(w.elements.va))?0:w.elements.va);
								vb1 += val/10000*w.elements.eatPart*(Number.isNaN(parseFloat(w.elements.vb1))?0:w.elements.vb1);
								vb2 += val/10000*w.elements.eatPart*(Number.isNaN(parseFloat(w.elements.vb2))?0:w.elements.vb2);
								vc += val/10000*w.elements.eatPart*(Number.isNaN(parseFloat(w.elements.vc))?0:w.elements.vc);
							}
						})
					}
			}
			this.elements.energyKc = parseFloat(energyKc).toFixed(2);
			this.elements.carbohydrate = parseFloat(carbohydrate).toFixed(2);
			this.elements.protein = parseFloat(protein).toFixed(2);
			this.elements.fat = parseFloat(fat).toFixed(2);
			this.elements.autunite = parseFloat(autunite).toFixed(2);
			this.elements.iron = parseFloat(iron).toFixed(2);
			this.elements.zicn = parseFloat(zicn).toFixed(2);
			this.elements.va = parseFloat(va).toFixed(2);
			this.elements.vb1 = parseFloat(vb1).toFixed(2);
			this.elements.vb2 = parseFloat(vb2).toFixed(2);
			this.elements.vc = parseFloat(vc).toFixed(2);
		},
		handlePickTag(tag,item) {
			if(this.dishesForm.features.length > 4) {
				this.$message.warning("菜品特点只能选择5项");
				return;
			}
			let tags = {
				pId: item.id,
				cId: tag.id,
				itemDictCode: item.itemDictCode,
				itemDictName: item.itemDictName,
				itemDictValue: item.itemDictValue,
				valueDictCode: tag.valueDictCode,
				valueDictName: tag.valueDictName,
				valueDictValue: tag.valueDictValue
			}
			this.dishesForm.features.push(tags);
			item.dishesFeatureModelList.splice(item.dishesFeatureModelList.indexOf(tag),1);
		},
		sortNumber(a,b){
			return a.id - b.id;
		},
		handleTagClose(tag) {
			this.dishesForm.features.splice(this.dishesForm.features.indexOf(tag), 1);
			this.featureList.map(item=>{
				if(item.id==tag.pId) {
					let tagObj = {id: tag.cId, valueDictCode: tag.valueDictCode,valueDictName:tag.valueDictName,valueDictValue:tag.valueDictValue};
					item.dishesFeatureModelList.push(tagObj);
					item.dishesFeatureModelList.sort(this.sortNumber);
				}
			})
		},
		queryDishesDetail(id) {
			if(id) {
				queryDishesDetail(id).then(response=>{
					queryIngredientsList(id, this.crowdId).then(weight=>{
						this.dishesForm = response.data;
						this.changeEditBigCate(this.dishesForm.bigCateId);
						if(weight.data) {
							let weights = weight.data;
							this.elements.energyKc = parseFloat(weights.energyKc).toFixed(2);
							this.elements.carbohydrate = parseFloat(weights.carbohydrate).toFixed(2);
							this.elements.protein = parseFloat(weights.protein).toFixed(2);
							this.elements.fat = parseFloat(weights.fat).toFixed(2);
							this.elements.autunite = parseFloat(weights.autunite).toFixed(2);
							this.elements.iron = parseFloat(weights.iron).toFixed(2);
							this.elements.zicn = parseFloat(weights.va).toFixed(2);
							this.elements.vb1 = parseFloat(weights.vb1).toFixed(2);
							this.elements.vb2 = parseFloat(weights.vb2).toFixed(2);
							this.elements.vc = parseFloat(weights.vc).toFixed(2);
							this.dishesForm.ingredientsWeights = weights.ingredientsMap;
						}
					})	
				})
			}
		},
		goBack() {
			this.$router.push({name:'dishesList',path: '/datacenter/dishes',params: {page: this.$route.query.page}});
		},
    onSubmit() {
      console.log(this.dishesForm);
			this.$refs['dishesForm'].validate(valid => {
          if (valid) {
						if(this.dishesForm.id) {
							updateDishes(this.dishesForm).then(response=>{
								this.$message.success("菜品更新成功");
								this.goBack();
							})
						} else {
							saveDishes(this.dishesForm).then(response=>{
								this.$message.success("菜品保存成功");
								this.$router.push({ path: '/datacenter/dishes' })
							})
						}
					}
			})
    }
  }
};
</script>

<style lang="scss" scoped>
.data-ingedit {
  margin-top: 15px;
	margin-left: 15px;
	padding-bottom: 30px;
	position: relative;
}
.el-form-item.is-required.el-form-item--mini .el-form-item__content .el-form-item.is-required.el-form-item--mini {
	margin-bottom: 15;
}
.list-group-item {
	font-size: 12px;
	height: 25px;
	margin-bottom: 6px;
	line-height: 25px;
   &:hover .list-group-content{
      background-color:rgb(225, 225, 225);
      .del {
        display: inline-block;
        height: 20px;
        width: 30px;
        position: absolute;
        right: -35px;
        cursor: pointer;
        span {
          display:inline-block;
        }
      }
    }
}
.list-group-content {
	padding-left: 10px;
  background-color: #fafafa;
  display: inline-block;
  width: 320px;
  position: relative;
  .del span{
    display: none;
  }
}
.elms_ranking {
	position: absolute;
  top: 0;
  left: 430px;
  font-size: 12px;
}
._tips {
	display: inline-block;
	font-size: 12px;
	color: #a8a8a8;
}
.dishes_features_tips {
	position: absolute;
	top: -40px;
	right: 0;
}
.ingredients_map {
	height: 20px;
	line-height: 20px;
}
.ingredients_map_name {
    width: 80px;
    display: inline-block;
    margin-bottom: 6px;
}
.ingredients_map_weight{
	width: 40px;
    display: inline-block;
    text-align: right;
}
.ingredients_map_unit {
	text-align: left;
	display: inline-block;
  padding-left: 10px;
}
  .avatar-uploader-icon_1 {
    font-size: 28px;
    color: #8c939d;
		border-radius: 6px;
    width: 200px;
    height: 125px;
    line-height: 125px;
    text-align: center;
  }
	.photo {
		position:relative
	}
	.photo:hover .test_1{
		display: block;
	}
  .test_1 {
		position: absolute;
    width: 200px;
    top: 0;
    height: 125px;
    display: none;
    background-color: rgba(0,0,0,0.5);
		opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/views/datacenter/components/basedata/dishes/edit.vue